module.exports = __webpack_public_path__ + "static/media/Modal-Top.0c134b48.svg";